import { jsx as _jsx } from "react/jsx-runtime";
import { FormHelperText as ChakraFormHelperText, } from '@chakra-ui/react';
/**
 * Assistive component that conveys additional guidance about the field,
 * such as how it will be used and what types in values should be provided.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/formcontrol
 */
export function FormHelperText({ children, ...props }) {
    return _jsx(ChakraFormHelperText, { ...props, children: children });
}
//# sourceMappingURL=formhelpertext.js.map